import React, { useEffect, useMemo, useRef, useState } from 'react';
import SwiperCore from 'swiper';
import { Keyboard } from 'swiper/modules';
import { Swiper } from 'swiper/react';
import { ButtonWrapper, Root } from './styles';
import useButtons from './useButtons';
import { cx } from '@linaria/core';
SwiperCore.use([Keyboard]);
function getSwiperParams(alignment, updateSwiper) {
    const centerSlides = alignment === 'center';
    return {
        spaceBetween: 0,
        slidesPerView: 'auto',
        a11y: {
            enabled: false, // we need to deactivate this because we set our own roles for swipers that are navbars
        },
        centerInsufficientSlides: centerSlides,
        keyboard: {
            enabled: true,
        },
        threshold: 20,
        onSwiper: updateSwiper,
    };
}
export function Navbar({ items = [], type = 'default', accessibility = 'menu', isSwipeable = false, alignment = 'left', buttonType, hasControlledItems = false, id, ariaLabelledby, label, }) {
    /** Variables */
    const buttonWrapperRef = useRef(null);
    const [itemsState, setItemsState] = useState(items);
    const swiperRef = useRef({});
    function updateSwiper(swiper) {
        swiperRef.current = swiper;
    }
    const swiperParams = getSwiperParams(alignment, updateSwiper);
    const { memoButtons, memoButtonsSwipable } = useButtons(itemsState, setItemsState, hasControlledItems, accessibility, buttonType);
    const activeIndex = useMemo(() => itemsState.findIndex((element) => !!element.isActive), [itemsState]);
    /** Construktor-Hook & Effect-Hooks */
    useEffect(() => {
        setItemsState(items);
    }, [items]);
    /** JSX */
    return (React.createElement("nav", { className: cx(Root.base, Root.alignment[alignment]), id: id, "aria-label": label }, isSwipeable ? (React.createElement(Swiper, { ...swiperParams, role: accessibility, "aria-labelledby": ariaLabelledby, initialSlide: activeIndex }, memoButtonsSwipable)) : (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: cx(ButtonWrapper.base, ButtonWrapper.alignment[alignment]), role: accessibility, ref: buttonWrapperRef, "aria-labelledby": ariaLabelledby }, memoButtons)))));
}
export default React.memo(Navbar);
